<template>
  <div>
    <HistoryLogCom :fullNode="fullNode"/>

    <table class="detail-table">
      <tbody>
        <tr>
          <td class="label-col">无需启动会</td>
          <td>
            <el-tag type="danger"
                    v-if="fullNode.project_node.node_result.no_kickoff_meeting">
              无需启动会
            </el-tag>
            <el-tag type="success"
                    v-else>
              需要启动会
            </el-tag>
            <span class="form-item-tip">常规项目可不需要填写启动会时间，开启后将跳过时间填写</span>
          </td>
        </tr>
        <tr>
          <td class="label-col">启动会记录</td>
          <td>
            <template v-for="(item, index) in getMeetingList()">
              <div :key="index" class="record-item">
                <el-tag type="">第 {{ item.seq_no }} 次</el-tag>
                <span>
                  <i class="el-icon-time"></i>
                  {{ item.kickoff_meeting_time }}丨填写人: {{ item.submit_admin_name }}
                </span>
                <br><br>
                <span>
                  <i class="el-icon-user"></i>
                  参会人: {{ getAttendeeNames(item.attendees) }}
                </span>
              </div>
            </template>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

import HistoryLogCom from '@views/project/node-views/HistoryLogCom.vue'

export default {
  components: {HistoryLogCom},
  mixins: [],
  props: {
    fullNode: {
      type: Object,
      default: () => {},
    },
    projectId: {
      type: String,
      default: '0',
    }
  },
  data () {
    return {
      node: {
        node_result: {}
      },
    }
  },
  created () {},
  computed: {},
  watch: {},
  methods: {
    getMeetingList () {
      const nodeResult = _.get(this.fullNode, 'project_node.node_result', {})
      if (nodeResult.version === 2) {
        return [nodeResult.kickoff_meeting]
      }
      return _.get(nodeResult, 'kickoff_meeting_list', [])
    },
    getAttendeeNames (attendees) {
      if (!Array.isArray(attendees) || attendees.length === 0) {
        return '(无参会人)'
      }
      const names = attendees.map(a => a.name)
      return [...new Set(names)].join('、')
    }
  },
}
</script>

<style lang="scss" scoped>
.form-item-tip {
  font-size: 12px;
  color: #909399;
  margin-left: 10px;
}
.record-item {
  margin-bottom: 5px;
  &:last-child {
    margin-bottom: 0;
  }
}
.detail-table {
  width: 100%;
  margin-top: 15px;
  border-collapse: collapse;
  border: 1px solid #ebeef5;
  table-layout: fixed;
}
.detail-table td {
  padding: 12px 10px;
  border: 1px solid #ebeef5;
  color: #606266;
  font-size: 14px;
}
.detail-table .label-col {
  width: 100px;
  background-color: #fafafa;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/views/project/node-views/KickoffMeetingView.vue